module.exports = __webpack_public_path__ + "img/banking-icon-main.836afc5.png";